// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".forgot-password .form-group {\n  margin-bottom: 16px;\n}\n.forgot-password .form-group > label {\n    margin-bottom: 8px;\n    display: flex;\n    font-size: 20px;\n    color: #797979;\n}\n@media (max-width: 1199px) {\n.forgot-password .form-group > label {\n        font-size: 16px;\n}\n}\n.forgot-password .input-wrapper .icon-right {\n  cursor: pointer;\n  position: absolute;\n  right: 10px;\n  top: 14px;\n  background-color: #53a7d6;\n  z-index: 3;\n}\n", ""]);
// Exports
module.exports = exports;
